import type { IShipment } from '../../types/shipment'

interface IGenerateLoadboardURL {
  filterType: 'initialFilter' | 'fallbackFilter'
  hasAvailableBackhauls: boolean
  shipment: IShipment
  workspacename?: string | null
}

/**
 * Generates the loadboard URL based on the given workspace name.
 */
export const generateLoadboardURL = ({
  hasAvailableBackhauls,
  filterType,
  shipment,
  workspacename
}: IGenerateLoadboardURL): string => {
  if (!workspacename) return ''
  if (!hasAvailableBackhauls && filterType === 'fallbackFilter') {
    return `/${workspacename}`
  }

  const stops = shipment?.stops ?? []
  if (stops.length === 0) return `/${workspacename}`

  // Get first and last stops
  const [firstStop, ...remainingStops] = stops
  const lastStop = remainingStops[remainingStops.length - 1] || firstStop

  // Extract address data
  const originData = lastStop?.warehouse?.address
  const destData = firstStop?.warehouse?.address
  const originDate = lastStop?.appointment?.start?.date

  // Build query parameters
  const params: Record<string, string> = {
    origin_radius: '150'
  }

  // Add origin parameters
  if (originData) {
    originData.addressLabel && (params.origin = originData.addressLabel)
    if (originData.coordinates?.latitude != null && originData.coordinates?.longitude != null) {
      params.origin_lat = originData.coordinates.latitude.toString()
      params.origin_lng = originData.coordinates.longitude.toString()
    }
  }

  // Add date parameters
  if (originDate) {
    const parsedDate = new Date(originDate)
    // Validate that the date is valid before using it
    if (!isNaN(parsedDate.getTime())) {
      params.origin_start_date = originDate
      const nextDate = new Date(parsedDate)
      nextDate.setDate(nextDate.getDate() + 1)
      params.origin_end_date = nextDate.toISOString().split('T')[0]
    }
  }

  // Add destination parameters for initial filter
  if (filterType === 'initialFilter' && destData) {
    params.destination_radius = '150'
    destData.addressLabel && (params.destination = destData.addressLabel)
    if (destData.coordinates?.latitude != null && destData.coordinates?.longitude != null) {
      params.destination_lat = destData.coordinates.latitude.toString()
      params.destination_lng = destData.coordinates.longitude.toString()
    }
  }

  const queryString = new URLSearchParams(params).toString()
  return `/${workspacename}/public/posts${queryString ? `?${queryString}` : ''}`
}
